import { render, staticRenderFns } from "./SupportSessionBar.vue?vue&type=template&id=6537b73c"
import script from "./SupportSessionBar.vue?vue&type=script&lang=js"
export * from "./SupportSessionBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports